import { render, staticRenderFns } from "./UserPositionDetailContainer.vue?vue&type=template&id=394db39f&scoped=true&"
import script from "./UserPositionDetailContainer.vue?vue&type=script&lang=js&"
export * from "./UserPositionDetailContainer.vue?vue&type=script&lang=js&"
import style0 from "./UserPositionDetailContainer.vue?vue&type=style&index=0&lang=css&"
import style1 from "./UserPositionDetailContainer.vue?vue&type=style&index=1&id=394db39f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394db39f",
  null
  
)

export default component.exports